/* -------------------------------------------------------------------------- */
/*  Sage 300 family renderer                                                    */
/* -------------------------------------------------------------------------- *
 *  Emits a Sage 300 import: the "*" header, then per-row detail records. Line  *
 *  items are split into their non-zero LMSEO buckets (via identifyCategory);   *
 *  each split and each markup is rendered by the tenant's own record builders, *
 *  which own the exact column layout. A tenant whose logic doesn't fit the     *
 *  declarative path supplies `render` instead.                                 */
/* -------------------------------------------------------------------------- */

import { identifyCategory } from "../../categories";
import { BudgetImportConfig, BudgetImportContext } from "../types";

export function renderSage(ctx: BudgetImportContext, config: BudgetImportConfig): string[] {
  if (config.format !== "sage") throw new Error(`renderSage received a ${config.format} config`);
  const options = config.sage;
  if ("render" in options) return options.render(ctx);

  const lines: string[] = [options.buildHeader(ctx)];
  for (const row of ctx.rows) {
    if (row.type === "line_item") {
      for (const [category, unitCost] of identifyCategory(row, options.categoryMap)) {
        lines.push(...options.renderLineItem({ row, category, unitCost, ctx }));
      }
    } else if (row.type === "markup") {
      lines.push(...options.renderMarkup({ row, ctx }));
    }
  }
  return lines;
}
